"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unregistered_bidders_for_client = void 0;
var api_1 = require("../../../api");
// interface IReq {
//   client_entity_id: number;
// }
var unregistered_bidders_for_client = function (client_id, pagination) {
    return (0, api_1.apiGet)({
        endpoint: "v3/bidder/unregistered_bidders_for_client",
        query: __assign({ client_entity_id: client_id }, pagination),
    });
};
exports.unregistered_bidders_for_client = unregistered_bidders_for_client;
